export default {
  zh: {
    topLovers:"Top Lovers",
    rule: 'Rules',
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
    rule: 'القواعد',
    timeR: 'العد التنازلي',
    days: 'أيام',
    ranking:"التصنيف",
    rewards:"جوائز",
    rulesDeil:`1. خلال شهر رمضان، سيتم تسجيل الهدايا التي يرسلها المستخدمون على البرودكاست وإحصاءها في هذه القائمة.<br/><br/>

    2. سيتم احتساب جميع الهدايا التي يرسلها المستخدمين خلال فترة الحدث.<br/><br/>
    
    3. بعد الحدث، سيحصل أفضل 10 مستخدمين على مكافآت.`,
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`1.During Ramadan , gifts sent by users on broadcast will be recorded and tallied in this list.<br/><br/>
    2.Gifts sent by users with multiple messages will be combined and counted.<br/><br/>
    3.After the event, the top 10 users will receive rewards.`,
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    rule: 'Kural',
    timeR: 'Kalan süre: ',
    days: 'gün',
    ranking:"Sıralama",
    rewards:"Ödüller",
    rulesDeil:`1.Ramazan ayı boyunca yayında kullanıcıların gönderdiği hediyeler bu listeye kaydedilecek ve sayılacaktır.<br/><br/>
    2.Kullanıcıların birden fazla mesajla gönderdiği hediyeler birleştirilecek ve sayılacaktır.<br/><br/>
    3.Etkinlik sonrasında ilk 10 kullanıcıya ödüller verilecektir.`

  },
  pt:{
    topLovers: "Top Amantes",
    treeOfLovers: "Árvore dos Amantes",
    rule: 'Regras',
    timeR: 'Contagem regressiva: ',
    days: 'dias',
    ranking: "Classificação",
    rewards: "Recompensas",
    rulesDeil: `1. Durante o Ramadã, os presentes enviados pelos usuários na transmissão serão registrados e contabilizados nesta lista.<br/><br/>
    2. Os presentes enviados por usuários com várias mensagens serão combinados e contados.<br/><br/>
    3. Após o evento, os 10 melhores usuários receberão recompensas.`,

  },
  id:{
    topLovers: "Pecinta Teratas",
    treeOfLovers: "Pohon Pecinta",
    rule: 'Aturan',
    timeR: 'Hitung mundur: ',
    days: 'hari',
    ranking: "Peringkat",
    rewards: "Hadiah",
    rulesDeil: `1. Selama Ramadan, hadiah yang dikirim oleh pengguna di siaran akan tercatat dan dihitung dalam daftar ini.<br/><br/>
    2. Hadiah yang dikirim oleh pengguna dengan beberapa pesan akan digabungkan dan dihitung.<br/><br/>
    3. Setelah acara, 10 pengguna teratas akan menerima hadiah.`,

  },
  uz:{
    topLovers: "Eng Yaxshi Sevuvchilar",
    treeOfLovers: "Sevuvchilar Daraxti",
    rule: 'Qoidalar',
    timeR: 'Orqaga qaytish: ',
    days: 'kunlar',
    ranking: "Reyting",
    rewards: "Mukofotlar",
    rulesDeil: `1. Ramadan oyida, foydalanuvchilar tomonidan yuborilgan sovg'alar bu ro'yxatda qayd etiladi va hisoblanadi.<br/><br/>
    2. Bir nechta xabar yuborgan foydalanuvchilar tomonidan yuborilgan sovg'alar birlashtiriladi va hisoblanadi.<br/><br/>
    3. Tadbirdan so'ng, eng yuqori 10 foydalanuvchi mukofotlar oladi.`
},
    ru:{
    topLovers: "Топ влюбленных",
    treeOfLovers: "Дерево влюбленных",
    rule: 'Правила',
    timeR: 'Обратный отсчет: ',
    days: 'дни',
    ranking: "Рейтинг",
    rewards: "Награды",
    rulesDeil: `1. Во время Рамадана подарки, отправленные пользователями в эфире, будут записаны и подсчитаны в этом списке.<br/><br/>
    2. Подарки, отправленные пользователями с несколькими сообщениями, будут объединены и подсчитаны.<br/><br/>
    3. После завершения события, 10 лучших пользователей получат награды.`
},
    fa:{
    topLovers: "برترین عاشقان",
    treeOfLovers: "درخت عاشقان",
    rule: 'قوانین',
    timeR: 'شمارش معکوس: ',
    days: 'روزها',
    ranking: "رتبه بندی",
    rewards: "جوایز",
    rulesDeil: `1. در طول ماه رمضان، هدایایی که توسط کاربران در پخش زنده ارسال می‌شود در این لیست ثبت و شمارش خواهد شد.<br/><br/>
    2. هدایایی که توسط کاربران با پیام‌های متعدد ارسال می‌شود ترکیب و شمارش خواهد شد.<br/><br/>
    3. پس از پایان رویداد، 10 کاربر برتر جوایز دریافت خواهند کرد.`
}



}



// WEBPACK FOOTER //
// src/pages/activity/newRamadan/lang.js